var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.322,
    height: 13.597,
    viewBox: "0 0 15.322 13.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(-1085.945 -482.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M1101.267,494.616a1.284,1.284,0,0,1-1.42.989q-2.528,0-5.056,0-3.673,0-7.345,0a2.477,2.477,0,0,1-.591-.063,1.127,1.127,0,0,1-.822-1.56,2.651,2.651,0,0,1,.2-.417q3.088-5.352,6.184-10.7a2.274,2.274,0,0,1,.429-.549,1.07,1.07,0,0,1,1.533.038,2.4,2.4,0,0,1,.392.505q3.114,5.346,6.215,10.7a5.172,5.172,0,0,1,.282.7Zm-7.677.234q3.075,0,6.15,0a1.813,1.813,0,0,0,.472-.058.348.348,0,0,0,.253-.466,1.644,1.644,0,0,0-.155-.37q-3.1-5.366-6.2-10.729a1.534,1.534,0,0,0-.242-.32.358.358,0,0,0-.553,0,1.585,1.585,0,0,0-.242.32q-3.1,5.363-6.2,10.729a1.52,1.52,0,0,0-.149.341.359.359,0,0,0,.285.5,1.85,1.85,0,0,0,.443.052Q1090.523,494.853,1093.59,494.851Z",
    transform: "translate(0)",
    fill: "#b92222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M1214.934,547.857c0,.813,0,1.626,0,2.439a.4.4,0,0,1-.174.372.377.377,0,0,1-.581-.28c0-.035,0-.07,0-.1q0-2.446,0-4.892a.628.628,0,0,1,.069-.282.355.355,0,0,1,.4-.158.37.37,0,0,1,.278.333c.008.2,0,.4,0,.6Q1214.934,546.87,1214.934,547.857Z",
    transform: "translate(-120.962 -59.362)",
    fill: "#b92222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M1209.7,662.176a.67.67,0,1,1,0,1.34.67.67,0,0,1,0-1.34Z",
    transform: "translate(-116.107 -169.952)",
    fill: "#b92222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.48852bb4229c662d71777b99ca86b0cb.svg";
export { ForwardRef as ReactComponent };